export function calcPageNumber(first: number, rows: number): number {
  return Math.round(first / rows) + 1;
}
